export default __webpack_public_path__ + "static/media/arrival-banner-4.75883567.svg";